"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.slugfy = void 0;
const slugfy = (slug) => (slug || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9\-\s]/gi, '')
    .trim()
    .split(' ')
    .join('-');
exports.slugfy = slugfy;
